import actionType from '../constants/action-types';
import integrationTypes from '../constants/integration-types';

function integrationType(state = integrationTypes.NONE, action) {
  switch (action.type) {
    case actionType.SET_INTEGRATION:
      return action.payload.type;
    default:
      return state;
  }
}

export default integrationType;
